import {request} from '../utils/request'
import {rbacApi} from '../config/urlConfig';
import {md5EncryptAddSalt} from "../utils/captcha";

/**
 * 查询所有用户
 */
export const findUserList = (data: any) =>
  request({
    url: `${rbacApi}/users/list`,
    method: 'post',
    data
  })


export const login = (payload: any) => {
    let data = {...payload};
    data.password = md5EncryptAddSalt(`${data.username}:`, data.password);
    return request({
        url:  `${rbacApi}/users/login`,
        method: 'post',
        data
    })
}


/**
 * 微信绑定
 * @param data
 * @returns
 */
export const bindWechat = (data: any) =>
    request({
        url:  `${rbacApi}/users/bindWechat`,
        method: 'post',
        data
    })

/** 微信授权回调，status: unbind | bind | frozen | error */
export const wxAuthCallback = (code: string, state = '') =>
    request({
        url: `/wechat-service-api/users/wxAuthCallback?${new URLSearchParams({ code, state })}`,
        method: 'get',
    });



// 账号密码注册（完成创建租户和用户名）
export const registerSetting = (data: any) =>
    request({
        url:  `${rbacApi}/users/registerSetting`,
        method: 'post',
        data
    })


/**
 * 根据账号查询用户信息是否存在
 */
export const isUserExistByAccount = (name: string) =>
    request({
        url: `${rbacApi}/users/isUserExistByAccount/${name}`,
        method: 'get'
    })